var React = require('react');

function Active (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1","width":"38","height":"38","rx":"19","fill":"black","fillOpacity":"0.75","key":0}),React.createElement("rect",{"x":"1","y":"1","width":"38","height":"38","rx":"19","stroke":"#D6A444","strokeWidth":"2","key":1}),React.createElement("circle",{"cx":"20","cy":"20","r":"10","fill":"#D6A444","key":2})]);
}

Active.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Active;

Active.default = Active;
